// LiveMonitorUtils.js

export const feedConfig = {
  feed1: { shortName: "F1", longName: "Primary Feed", colour: "#6B4C9A" },
  feed2: { shortName: "F2", longName: "Secondary Feed", colour: "#E67E22" },
  feed3: { shortName: "F3", longName: "Tertiary Feed", colour: "#2980B9" }
};

export const formatCountdown = (totalSeconds) => {
  if (totalSeconds === null || totalSeconds === undefined) return "--:--";

  const isNegative = totalSeconds < 0;
  const absSeconds = Math.abs(totalSeconds);
  const minutes = Math.floor(absSeconds / 60);
  const seconds = absSeconds % 60;
  const zeropaddedSeconds = seconds < 10 ? "0" : "";

  return `${isNegative ? "-" : ""}${minutes}:${zeropaddedSeconds}${seconds}`;
};

export const formatRelativeTime = (targetSecs, baseSecs) => {
  if (targetSecs === null || targetSecs === undefined || baseSecs === null || baseSecs === undefined) return "--:--";

  const difference = targetSecs - baseSecs;
  if (difference === 0) return "Base";

  const sign = difference > 0 ? "+" : "-";
  const absDifference = Math.abs(difference);
  const minutes = Math.floor(absDifference / 60);
  const seconds = absDifference % 60;
  const zeroPaddedSeconds = seconds < 10 ? "0" : "";

  return `${sign}${minutes}:${zeroPaddedSeconds}${seconds}`;
};

export const getOccupancyTally = (occupancy) => {
  if (occupancy === null || occupancy === undefined) return "-";

  let score = 0;
  if (typeof occupancy === "string") {
    if (occupancy.includes("seatsAvailable")) score = 1;
    else if (occupancy.includes("standingAvailable")) score = 3;
    else if (occupancy.includes("full")) score = 5;
  } else {
    const value = Number(occupancy);
    if (value === 0 || value === 1) score = 1;
    else if (value === 2) score = 2;
    else if (value === 3) score = 3;
    else if (value === 4) score = 4;
    else if (value === 5 || value === 6) score = 5;
  }
  return score;
};

export const getFeedTimeValue = (departureItem, targetFeedKey, mode, baselineFeed, currentUnixTime) => {
  const epoch = departureItem[`${targetFeedKey}Epoch`];
  const hasHistory = epoch !== undefined && epoch !== null;
  const isActiveNow = departureItem[`${targetFeedKey}Active`];

  if (hasHistory && !isActiveNow) return "⊘";

  const targetSecs = hasHistory ? epoch - currentUnixTime : null;

  if (mode === "absolute") return formatCountdown(targetSecs);

  const baseEpoch = departureItem[`${baselineFeed}Epoch`];
  const baseSecs = (baseEpoch !== undefined && baseEpoch !== null) ? baseEpoch - currentUnixTime : null;

  if (baseSecs === null || baseSecs === undefined) return formatCountdown(targetSecs);

  return formatRelativeTime(targetSecs, baseSecs);
};

export const createPopupHtml = (dep, mode, baseline, currentUnixTime) => {
  const f1Str = getFeedTimeValue(dep, "feed1", mode, baseline, currentUnixTime);
  const f2Str = getFeedTimeValue(dep, "feed2", mode, baseline, currentUnixTime);

  const f1Icon = dep.feed1Realtime && dep.feed1Active && f1Str !== "⊘" ? "⏳" : "";
  const f2Icon = dep.feed2Realtime && dep.feed2Active && f2Str !== "⊘" ? "⏳" : "";

  const f1Tally = f1Str !== "⊘" ? `(${getOccupancyTally(dep.feed1Occupancy)})` : "";
  const f2Tally = f2Str !== "⊘" ? `(${getOccupancyTally(dep.feed2Occupancy)})` : "";

  return `
    <div style="font-family: Inter, Arial, sans-serif; padding: 4px; min-width: 165px;">
      <div style="font-size: 14px; font-weight: 700; color: #344767; margin-bottom: 6px; text-align: center;">
        Route ${dep.routeShortName}
      </div>
      <div style="display: flex; flex-direction: column; gap: 4px; border-top: 1px solid #f1f5f9; padding-top: 6px; font-family: monospace; font-size: 11px;">
        <div style="color: ${feedConfig.feed1.colour}; display: flex; justify-content: space-between; gap: 8px;">
          <span>${feedConfig.feed1.shortName}: <strong>${f1Str}${f1Icon}</strong></span>
          <span>${f1Tally}</span>
        </div>
        <div style="color: ${feedConfig.feed2.colour}; display: flex; justify-content: space-between; gap: 8px;">
          <span>${feedConfig.feed2.shortName}: <strong>${f2Str}${f2Icon}</strong></span>
          <span>${f2Tally}</span>
        </div>
      </div>
    </div>
  `;
};